/* eslint-disable camelcase */
import { TagType } from 'components/ModalTimeline/ClaimStatus';
import { IconType } from 'react-icons';

export enum CLAIMS_TYPES {
  TOGGLE_OPEN_MODAL = '@claims/TOGGLE_OPEN_MODAL',
  CLEAN_CLAIMS = '@claims/CLEAN_CLAIMS',

  SEARCH_CLAIMS_REQUEST = '@claims/SEARCH_CLAIMS_REQUEST',
  SET_SEARCH_CLAIMS = '@claims/SET_SEARCH_CLAIMS',

  CLEAN_TIMELINE = '@claims/CLEAN_TIMELINE',

  GET_CLAIMS_BY_STATUS_REQUEST = '@claims/GET_CLAIMS_BY_STATUS_REQUEST',
  SET_CLAIMS_BY_STATUS = '@claims/SET_CLAIMS_BY_STATUS',

  GET_CLAIMS_BY_TYPE_REQUEST = '@claims/GET_CLAIMS_BY_TYPE_REQUEST',
  GET_CLAIMS_ACTIVE = '@claims/GET_CLAIMS_ACTIVE',
  GET_CLAIMS_COMPLETED = '@claims/GET_CLAIMS_COMPLETED',

  GET_STEPS_BY_CLAIM_ID = '@claims/GET_STEPS_BY_CLAIM_ID',
  SET_STEPS_BY_CLAIM_ID = '@claims/SET_STEPS_BY_CLAIM_ID',

  GET_CLAIM_BY_ID = '@claims/GET_CLAIM_BY_ID',
  SET_CLAIM_BY_ID = '@claims/SET_CLAIM_BY_ID',

  GET_STATUS_REQUEST = '@claims/GET_STATUS_REQUEST',
  GET_STATUS = '@claims/GET_STATUS',

  GET_STATES_REQUEST = '@claims/GET_STATES_REQUEST',
  GET_STATES = '@claims/GET_STATES',

  GET_STATUS_ACTIONS = '@claims/GET_STATUS_ACTIONS',
  SET_STATUS_ACTIONS = '@claims/SET_STATUS_ACTIONS',

  DELETE_DRAFT = '@claims/DELETE_DRAFT',
  INVALID_ACTIVE_CLAIMS_RESPONSE = '@claims/INVALID_ACTIVE_CLAIMS_RESPONSE',

  SET_TIMELINE_CLAIM_ID = '@claims/SET_TIMELINE_CLAIM_ID',

  GET_TRF_REM_BY_CLAIM_ID = '@claims/GET_TRF_REM_BY_CLAIM_ID',
  SET_TRF_REM_BY_CLAIM_ID = '@claims/SET_TRF_REM_BY_CLAIM_ID',
}

export interface ClaimType {
  results: IClaim[];
  hasMore?: boolean;
  responseValid?: boolean;
}
export interface Status {
  id: number;
  name: string;
}

export interface States {
  id: number;
  name: string;
  acronym: string;
  region: string;
}

export interface ClaimsState {
  status: Status[];
  states: States[];
  active: ClaimType;
  completed: ClaimType;
  drafts: ClaimType;
  searchClaims: SearchClaim[];
  hasDraftModalOpen: boolean;
  stepsClaimStatus: StepClaimStatus[];
  claimById: IClaim;
  statusActions: StatusAction;
  timelineClaimId: string;
  trfRem: TrfRem[];
}

export interface GetClaims {
  searchTerms?: string;
  type?: 'active' | 'completed';
  status?: string;
  limit?: number;
  showMore?: boolean;
}

export interface GetClaimsByFilter {
  status?: string;
  startDate?: string;
  endDate?: string;
}

interface Address {
  city: string;
  uf: string;
}
export interface Franchise {
  code: string;
  name: string;
  address: Address;
}

export interface IClaim {
  claimWithoutUpdate: string;
  id: string;
  cp: string;
  franchise: Franchise;
  subCoverage: {
    name: string;
  };
  status: 'Em Análise' | 'Pendência' | 'Indenizado' | 'Encerrado' | 'Rascunho';
  number: string;
  updatedAt: number;
  createdAt: number;
  statusArray: any;
}

export interface StatusAction {
  id: string;
  number: string;
  documentAction: string[];
  fileAction: {
    url: string;
  };
  filesTutorial: [
    {
      filename: string;
      url: string;
    },
  ];
  hasFilesTutorial: boolean;
}

export interface SearchClaim {
  id: string;
  number: string;
  franchise: string;
  uf: string;
  createdAt: number;
  cp: string;
  status: string;
  statusBroker: string;
  coverage: string;
}

export interface StepClaimStatus {
  claimId?: string;
  status?: string;
  date?: Date;
  description?: string;
  icon?: IconType;
  color?: TagType;
  onButtonClick?: (id: string) => void;
  buttonTitle?: string;
  statusBroker?: string;
}

export interface TrfRemData {
  data: TrfRem[];
}
export interface TrfRem {
  claimID: string;
  pct_taxa_remuneracao_franqueado: number;
  pct_recuperacao_esforco_marketing: number;
  pct_total_trf_rem: number;
  nr_ano_mes_periodo_formated: number;
  title: string;
  searchDate: string;
  status: string;
}
